// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"668":"d68dc095","718":"867d5a47"}[chunkId] + ".js";
};